<template>

    <div>
      <el-row>
        <el-col :span="24">
          <transition v-if="actionData" name="el-zoom-in-center">

            <!-- XOL-67 (B3): an RTA is its own record until it closes (no site row exists yet), so the drawer is
                 RtaDetails, read from the action; the site it may become has its own drawer. -->
            <section v-if="requestType === 'rta'" :class="requestType + '-bg-colour'">
              <rta-details :row-data="actionData" :tab="tab" :step-arg="stepArg" />
            </section>

            <section v-else>

              <div v-if="isActive(actionData)" :class="requestType + '-bg-colour'">
                <request-workflow class="padded" :row-data="actionData" :row-index="rowIndex" :close-dialog="closeDialog" />

              <hr />

            </div>
            <div v-else>

              <completed-request :row-data="actionData" :row-index="rowIndex" />

            </div>

          </section>

          </transition>
        </el-col>

      </el-row>
    </div>

</template>


<script>

import RequestMixins from '@/mixins/RequestMixins'
import * as sync from '@/lib/requestRowSync'

import RequestSearch from '@/components/requests/RequestSearch'

import RtaDetails from '@/components/requests/acquire/RtaDetails'
import CompletedRequest from '@/components/requests/workflow/CompletedRequest'
import RequestWorkflow from '@/components/requests/workflow/RequestWorkflow'


export default {
  mixins: [RequestMixins],

  components: {
    CompletedRequest,
    RtaDetails,
    RequestSearch,
    RequestWorkflow
  },

  props: {

    rowData: {
      type: Object,
      default: null
    },

    rowIndex: {
      type: Number
    },

    closeDialog: {
      type: Function,
      default: null
    },

    // When true and rowData is already fully-hydrated (e.g. by RequestDetailLayer),
    // skip the /actions/{id} re-fetch in created() and use rowData directly.
    skipInitialFetch: {
      type: Boolean,
      default: false
    },

    // XOL-67: the drawer's `tab` (legacy deep links) and `step` args, for an RTA. Other
    // request types ignore them. `stepArg`, not `step`: RequestMixins watches a `step` of its own.
    tab: {
      type: String,
      default: null
    },

    stepArg: {
      type: Number,
      default: null
    }

  },



  methods: {

    // XOL-596: one registered object per row, taken on load, so a later edit counts
    // against the loaded value. (XOL-586: opening a request writes nothing. The
    // recipient lists are live and kept by the API; the SPA no longer fills them.)
    registerRows () {
      this.syncRegisterRow(this.actionData, 'action')

      for (var i = 0; this.actionData.steps && i < this.actionData.steps.length; i++) {
        this.syncRegisterRow(this.actionData.steps[i], 'step')
      }
    },


    // XOL-596: a drawer re-initialised with a NEW data object leaves the old rows
    // behind; release their records (one that still has a field to save keeps its
    // record until it is saved).
    releaseRows (action) {
      if (!action) {
        return
      }

      sync.releaseRow(action)

      for (var i = 0; action.steps && i < action.steps.length; i++) {
        sync.releaseRow(action.steps[i])
      }
    },


    initRequest (data) {

      if (this.actionData && this.actionData !== data) {
        this.releaseRows(this.actionData)
      }

      this.actionData = data

      // An RTA registers its action row too (XOL-67): Emails Update and the mail-off switch
      // save emails.* through the per-field save, as on every request. It has no steps.
      if (this.actionData) {
        this.registerRows()
      }

    }  // initRequest

  },   // methods



  data () {
    return {
      actionData: null,
      requestType: (this.rowData.actionType ? this.rowData.actionType.toLowerCase() : 'rts')
    }

  },


  beforeDestroy () {

    // The list behind the drawer re-reads when it closes, for an RTA too (XOL-67 B10: the Acquire list and its Needs My Action
    // count showed the stage the RTA had when the drawer opened). The type is the loaded action's, else the row's: a drawer
    // closed before the action arrived has no actionData.
    let type = (this.actionData && this.actionData.actionType) || this.rowData.actionType

    if (type) {
       this.$events.emit(this.requestTableRef(type) + '-refresh-table')
    }

  },



  created () {
    if (this.skipInitialFetch) {
      // rowData is already hydrated by the caller (e.g. RequestDetailLayer).
      // Call initRequest directly (it registers the rows for saving) without
      // a second round-trip to /actions/{id}.
      this.initRequest(this.rowData)
    } else {
      // XOL-67: an RTA is read from its action too, not from a site (it has none until it completes).
      this.fetchData('/actions/' + this.rowData.id, this.initRequest)
    }

  }

}

</script>

<style scoped>
.el-select {display: inline-block; width: 100%;}
.rta-bg-colour {background-color: #FDF6EC;};
.rts-bg-colour {background-color: #F0F9EC;};
.rtu-bg-colour {background-color: #EDF5FF;};
.rtb-bg-colour {background-color: #F4F4F5;};
.rtd-bg-colour {background-color: #FEF0F0;};

</style>
